import { Trans } from 'react-i18next';

export const PoweredByFooter = () => (
  <p className="checkin-footer">
    <Trans
      i18nKey="branding.poweredBy"
      components={{
        product: (
          <a
            href="https://unitychurchmanager.com"
            target="_blank"
            rel="noopener noreferrer"
            className="checkin-footer-product"
          />
        ),
      }}
    />
  </p>
);
